import React from "react";
import { Divider } from "../../../../../components";

const DividerList = () => {
  return (
    <div className="flex flex-col flex-1 gap-2 my-5 items-center justify-center">
      <div className="w-full max-w-3xl flex flex-col gap-5 my-5 mx-auto">
        <Divider />
        <Divider>OR</Divider>

        <Divider textAlign="left">Text Left</Divider>

        <Divider textAlign="right">Text Right</Divider>

        <div className="flex items-center space-x-4 justify-center">
          <span>Vertical</span>
          <Divider orientation="vertical" flexItem />
          <span>Divider</span>
        </div>
        <Divider light>Divider light</Divider>
      </div>
    </div>
  );
};

export default DividerList;
